module.exports = {
      id: "glyph:heart-full-usage",
      viewBox: "0 0 20 18",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#glyph:heart-full-usage",
      toString: function () {
        return this.url;
      }
    }